<script>
export default {
    name: "Header",
    data() {
        return {
            hoveredIndex: null,
            isDropdownVisible: false,
        };
    },
    computed: {
        currentLanguage() {
            return this.$store.state.lang || localStorage.getItem('lang') || 'ru'
        }
    },
    methods: {
        navigateTo(route) {
            this.$router.push(route)
        },
        changeLanguage(lang) {
            this.$store.state.lang = lang
            localStorage.setItem('lang', lang)
            console.log(lang)
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible
        },
        goHome() {
            if (this.$route.path === '/')  {
                window.location.reload()
            } else {
                this.$router.push('/')
            }
        },
        goSignIn() {
                this.$router.push('/signin')
        },
    },
}
</script>

<template>
    <div class="navbar-section">
    <section class="navbar slide-up">
        <section class="logotype">
            <img src="@/assets/logo.svg" class="logo" @click="goHome">
        </section>
        <section class="navbar-right-side">
            <div class="language-container" @click= "toggleDropdown"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_65_140)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91998 0.5C14.8906 0.5 18.92 4.52939 18.92 9.5C18.92 14.4706 14.8906 18.5 9.91998 18.5C4.94937 18.5 0.919983 14.4706 0.919983 9.5C0.919983 4.52939 4.94937 0.5 9.91998 0.5ZM6.70119 11.1364C6.66583 10.6058 6.64725 10.0589 6.64725 9.5C6.64725 8.82564 6.67422 8.16846 6.72536 7.53644H2.48204C2.31704 8.16326 2.22915 8.82144 2.22915 9.5C2.22915 10.0615 2.28928 10.609 2.40353 11.1364H6.70119ZM6.82643 12.4455H2.81342C3.74267 14.6849 5.69963 16.3902 8.09565 16.9731C7.51138 15.8926 7.06094 14.3078 6.82643 12.4455ZM8.14679 12.4455H11.6932C11.5388 13.5943 11.2989 14.6054 11.0039 15.4166C10.738 16.1475 10.4525 16.6471 10.2012 16.9393C10.056 17.1083 9.96113 17.1665 9.91998 17.185C9.87883 17.1665 9.78395 17.1083 9.63873 16.9393C9.38744 16.6471 9.102 16.1475 8.83613 15.4166C8.5411 14.6054 8.30119 13.5943 8.14679 12.4455ZM11.8264 11.1364H8.01355C7.9764 10.61 7.95642 10.0629 7.95642 9.5C7.95642 8.81945 7.98539 8.16207 8.03912 7.53644H11.8009C11.8546 8.16207 11.8836 8.81945 11.8836 9.5C11.8836 10.0629 11.8636 10.61 11.8264 11.1364ZM13.0135 12.4455C12.779 14.3078 12.3286 15.8926 11.7443 16.9731C14.1403 16.3902 16.0973 14.6849 17.0266 12.4455H13.0135ZM17.4364 11.1364H13.1388C13.1741 10.6058 13.1927 10.0589 13.1927 9.5C13.1927 8.82564 13.1658 8.16846 13.1146 7.53644H17.3579C17.5229 8.16326 17.6108 8.82144 17.6108 9.5C17.6108 10.0615 17.5507 10.609 17.4364 11.1364ZM8.83613 3.58336C8.56946 4.31665 8.34774 5.21333 8.19353 6.22727H11.6465C11.5895 5.85254 11.5232 5.49379 11.4489 5.15341C11.3223 4.57293 11.172 4.04559 11.0039 3.58336C10.738 2.85247 10.4525 2.35289 10.2012 2.06066C10.1163 1.96178 10.0486 1.90086 9.99868 1.8637C9.96333 1.83734 9.93696 1.82275 9.91998 1.81496C9.87883 1.83354 9.78395 1.89167 9.63873 2.06066C9.45995 2.2686 9.2638 2.58161 9.06984 3.00828C8.99114 3.18106 8.91283 3.37263 8.83613 3.58336ZM12.9696 6.22727H16.8817C15.9034 4.14966 14.0223 2.58101 11.7443 2.0269C12.294 3.04363 12.7253 4.50661 12.9696 6.22727ZM2.95824 6.22727H6.87038C7.11467 4.50661 7.54593 3.04363 8.09565 2.0269C5.81769 2.58101 3.93663 4.14966 2.95824 6.22727Z" fill="white"/>
                </g>
                <defs>
                    <clipPath id="clip0_65_140">
                        <rect width="18" height="18" fill="white" transform="translate(0.919983 0.5)"/>
                    </clipPath>
                </defs>
            </svg>
                {{ currentLanguage.toUpperCase() }}
                <div v-if="isDropdownVisible" class="dropdown-menu">
                    <div @click = "changeLanguage('en')" class="language-button">English</div>
                    <div @click = "changeLanguage('de')" class="language-button">Deutsch</div>
                    <div @click = "changeLanguage('es')" class="language-button">Español</div>

                    <div @click = "changeLanguage('fr')" class="language-button">Français</div>
                    <div @click = "changeLanguage('pt')" class="language-button">Português (Brasil)</div>
                    <div @click = "changeLanguage('it')" class="language-button">Italiano</div>
                    <div @click = "changeLanguage('pl')" class="language-button">Polski</div>
                    <div @click = "changeLanguage('ru')" class="language-button">Русский</div>
                    <div @click = "changeLanguage('tr')" class="language-button">Türkçe</div>
                    <div @click = "changeLanguage('ja')" class="language-button">日本語</div>
                    <div @click = "changeLanguage('ar')" class="language-button">العربية</div>
                </div>
            </div>
            <div class="navbar-buttons-container">
                <a href="/CloudModsSetup.exe" download class="navbar-button">
                    <svg width="18" height="18" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 14.575C9.86667 14.575 9.74167 14.5542 9.625 14.5125C9.50833 14.4708 9.4 14.4 9.3 14.3L5.7 10.7C5.5 10.5 5.40417 10.2667 5.4125 10C5.42083 9.73333 5.51667 9.5 5.7 9.3C5.9 9.1 6.1375 8.99583 6.4125 8.9875C6.6875 8.97917 6.925 9.075 7.125 9.275L9 11.15V4C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3C10.2833 3 10.5208 3.09583 10.7125 3.2875C10.9042 3.47917 11 3.71667 11 4V11.15L12.875 9.275C13.075 9.075 13.3125 8.97917 13.5875 8.9875C13.8625 8.99583 14.1 9.1 14.3 9.3C14.4833 9.5 14.5792 9.73333 14.5875 10C14.5958 10.2667 14.5 10.5 14.3 10.7L10.7 14.3C10.6 14.4 10.4917 14.4708 10.375 14.5125C10.2583 14.5542 10.1333 14.575 10 14.575ZM4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V15C2 14.7167 2.09583 14.4792 2.2875 14.2875C2.47917 14.0958 2.71667 14 3 14C3.28333 14 3.52083 14.0958 3.7125 14.2875C3.90417 14.4792 4 14.7167 4 15V17H16V15C16 14.7167 16.0958 14.4792 16.2875 14.2875C16.4792 14.0958 16.7167 14 17 14C17.2833 14 17.5208 14.0958 17.7125 14.2875C17.9042 14.4792 18 14.7167 18 15V17C18 17.55 17.8042 18.0208 17.4125 18.4125C17.0208 18.8042 16.55 19 16 19H4Z" fill="white"/>
                    </svg>
                    {{__('Скачать')}}
                </a>
                <div v-if="$store.state.user" class="navbar-button">
                    {{$store.state.user.login}}
                </div>
                <div @click="goSignIn" class="navbar-button" v-else>
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_65_156)">
                        <path d="M0.614985 2.78287C0.257459 2.94717 0.0300293 3.29322 0.0300293 3.67291V13.3271C0.0300293 13.7068 0.257459 14.0528 0.614985 14.2171L6.45628 16.9016C7.14082 17.2161 7.93369 16.7385 7.93369 16.0115V0.988487C7.93369 0.26151 7.14082 -0.216145 6.45628 0.0984404L0.614985 2.78287Z" fill="white"/>
                        <path d="M9.51447 1.70579C9.08734 1.70579 8.74109 2.0373 8.74109 2.44624C8.74109 2.85518 9.08734 3.18669 9.51447 3.18669H12.1943C12.9061 3.18669 13.4832 3.73921 13.4832 4.42078V12.5791C13.4832 13.2606 12.9061 13.8131 12.1943 13.8131H9.51447C9.08734 13.8131 8.74109 14.1447 8.74109 14.5536C8.74109 14.9625 9.08734 15.294 9.51447 15.294H12.1943C13.7604 15.294 15.03 14.0785 15.03 12.5791V4.42078C15.03 2.92133 13.7604 1.70579 12.1943 1.70579H9.51447Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_65_156">
                            <rect width="15" height="17" fill="white" transform="translate(0.0300293)"/>
                        </clipPath>
                    </defs>
                    </svg>
                    {{__('Войти')}}
                </div>
            </div>
            <div class="navbar-buttons-container-mobile">
                <div class="navbar-button" @click="goSignIn"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_65_156)">
                        <path d="M0.614985 2.78287C0.257459 2.94717 0.0300293 3.29322 0.0300293 3.67291V13.3271C0.0300293 13.7068 0.257459 14.0528 0.614985 14.2171L6.45628 16.9016C7.14082 17.2161 7.93369 16.7385 7.93369 16.0115V0.988487C7.93369 0.26151 7.14082 -0.216145 6.45628 0.0984404L0.614985 2.78287Z" fill="white"/>
                        <path d="M9.51447 1.70579C9.08734 1.70579 8.74109 2.0373 8.74109 2.44624C8.74109 2.85518 9.08734 3.18669 9.51447 3.18669H12.1943C12.9061 3.18669 13.4832 3.73921 13.4832 4.42078V12.5791C13.4832 13.2606 12.9061 13.8131 12.1943 13.8131H9.51447C9.08734 13.8131 8.74109 14.1447 8.74109 14.5536C8.74109 14.9625 9.08734 15.294 9.51447 15.294H12.1943C13.7604 15.294 15.03 14.0785 15.03 12.5791V4.42078C15.03 2.92133 13.7604 1.70579 12.1943 1.70579H9.51447Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_65_156">
                            <rect width="15" height="17" fill="white" transform="translate(0.0300293)"/>
                        </clipPath>
                    </defs>
                </svg></div>
            </div>
        </section>
    </section>
    </div>
</template>

<style>
.slide-up {
    opacity: 0;
    transform: translateY(30px);
    animation: slideUp 0.8s ease-out forwards;
}

@keyframes slideUp {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.move-from-left-enter-from {
    transition: margin-right .2s ease;
    margin-right: -434px;
}

.move-from-left-enter-to {
    transition: margin-right .2s ease;
    margin-right: 0;
}

.move-from-left-leave-from {
    transition: margin-right .2s ease;
    margin-right: 0;
}

.move-from-left-leave-to {
    transition: margin-right .2s ease;
    margin-right: -434px;
}

.navbar-section {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.navbar {
    top: 0px;
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    z-index: 999;
}

.navbar-right-side {
    display: flex;
    align-items: center;
    flex-direction: row;
}

.navbar-buttons-container {
    display: flex;
    align-items: center;
    flex-direction: row;
}

.navbar-buttons-container-mobile {
    display: flex;
    align-items: center;
    flex-direction: row;
}

.navbar-button {
    display: flex;
    align-items: center;
    border: 1px solid #41414C;
    transition: 0.25s ease-in-out;

    font-weight: 600;
    letter-spacing: -0.36px;
    font-style: normal;
}

.navbar-button:hover {
    cursor: pointer;

    background: var(--color-main);
}

.language-container {
    display: flex;
    flex-direction: row;

    transition: 0.15s ease;
}

.language-container:hover {
    cursor: pointer;
}

.navbar {
    height: 56px;
    width: 320px;
}

.navbar-buttons-container {
    display: none;
}

.navbar-buttons-container-mobile {
    display: flex;
    gap: 16px;
}

.navbar-button {
    padding: 9px 16px;
    border-radius: 10px;
    gap: 8px;
    font-size: 16px;
    color: var(--text-primary);
}

.navbar-right-side {
    gap: 18px
}

.language-container {
    gap: 6px;
}

.logo {
    user-select: none;
    transition: 0.25s ease-in-out;
}

.logo:hover {
    cursor: pointer;
    opacity: 0.8;
}

.dropdown-menu {
    z-index: 999;
    position: absolute;
    top: 72px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    backdrop-filter: blur(34px);
    background: rgba(6, 6, 6, 0.80);
}

.language-button {
    display: flex;
    align-items: center;
    color: var(--text-secondary,);

    transition: 0.15s ease;
}

.language-button:hover {
    background: rgba(29, 29, 29, 0.60);
    cursor: pointer;
    color: var(--text-primary);
}

@media (min-width: 320px) {
    .navbar {
        height: 17.5vw;
        width: 100vw;
        padding: 0px 6.5vw;
    }

    .navbar-buttons-container {
        display: none;
    }

    .navbar-buttons-container-mobile {
        display: flex;
        gap: 5vw;
    }

    .navbar-button {
        padding: 2.8125vw 5vw;
        border-radius: 3.125vw;
        gap: 2.5vw;
        font-size: 5vw;
        color: var(--text-primary);
    }

    .navbar-right-side {
        gap: 5.625vw;
    }
    
    .language-container {
        gap: 3.75vw;
    }

    .dropdown-menu {
        border-radius: 3.75vw;
        padding: 3.75vw 3.75vw;
    }

    .language-button {
        width: 31.25vw;
        height: 7.5vw;
        border-radius: 3.75vw;
        padding: 6.25vw;
    }
}

@media (min-width: 464px) {
    .navbar {
        height: 56px;
        width: 464px;

        padding: 0px 0px;
    }

    .navbar-buttons-container {
        display: none;
    }

    .navbar-buttons-container-mobile {
        display: flex;
        gap: 16px;
    }

    .navbar-button {
        padding: 9px 16px;
        border-radius: 10px;
        gap: 8px;
        font-size: 16px;
        color: var(--text-primary);
    }

    .navbar-right-side {
        gap: 18px
    }

    .language-container {
        gap: 12px;
    }

    .dropdown-menu {
        border-radius: 12px;
        padding: 8px 8px;
    }

    .language-button {
        width: 100px;
        height: 24px;
        border-radius: 12px;
        padding: 12px;
    }
}

@media (min-width: 744px) {
    .navbar {
        height: 76px;
        width: 744px;
    }

    .navbar-buttons-container {
        display: flex;
        gap: 16px;
    }

    .navbar-buttons-container-mobile {
        display: none;
    }

    .navbar-button {
        padding: 9px 16px;
        border-radius: 10px;
        gap: 8px;
        font-size: 16px;
        color: var(--text-primary);
    }

    .navbar-right-side {
        gap: 18px
    }

    .language-container {
        gap: 6px;
    }

    .dropdown-menu {
        border-radius: 12px;
        padding: 8px 8px;
    }

    .language-button {
        width: 187px;
        height: 39px;
        border-radius: 12px;
        padding: 12px;
    }
}

@media (min-width: 984px) {
    .navbar {
        height: 76px;
        width: 984px;
    }

    .navbar-buttons-container {
        gap: 16px;
    }

    .navbar-button {
        padding: 9px 16px;
        border-radius: 10px;
        gap: 8px;
        font-size: 16px;
        color: var(--text-primary);
    }

    .navbar-right-side {
        gap: 18px
    }

    .language-container {
        gap: 6px;
    }

    .language-container {
        gap: 6px;
    }

    .dropdown-menu {
        border-radius: 12px;
        padding: 8px 8px;
    }

    .language-button {
        width: 150px;
        height: 39px;
        border-radius: 12px;
        padding: 12px;
    }
}

@media (min-width: 1248px) {
    .navbar {
        height: 76px;
        width: 1248px;
    }

    .navbar-buttons-container {
        gap: 16px;
    }

    .navbar-button {
        padding: 9px 16px;
        border-radius: 10px;
        gap: 8px;
        font-size: 16px;
        color: var(--text-primary);
    }

    .navbar-right-side {
        gap: 18px
    }

    .language-container {
        gap: 6px;
    }

    .dropdown-menu {
        border-radius: 12px;
        padding: 8px 8px;
    }

    .language-button {
        width: 187px;
        height: 39px;
        border-radius: 12px;
        padding: 12px;
    }
}
</style>